import type { AgentRun, HiveExecution } from "@/types";

/**
 * Agent activity derived from real executions — each in-flight execution's
 * current step is what an agent is doing right now. There is no separate
 * "agents" resource server-side; this view is honest by construction.
 */
export function agentRunsFromExecutions(executions: HiveExecution[]): AgentRun[] {
  return executions
    .filter((e) => e.status === "running" || e.status === "waiting" || e.status === "needs-approval")
    .map((e) => {
      const step = e.steps.find((s) => s.status === "running");
      return {
        id: e.id,
        name: step?.agent ?? e.agent ?? e.workflowName,
        app: "execution",
        status: e.status === "running" ? "running" : "queued",
        progress: e.progress,
        task: `${e.currentStep} · ${e.name}`,
        startedAt: e.startedAt,
      };
    });
}
